import type { StaticMobileAppsSmartAppBannerDto } from '@ori/static-api-client-react';

import type { UseMobileOs } from '../../hooks/useMobileOs';

export const APP_PROMO_LOCAL_STORAGE_KEY = 'hideAppPromoBannerUntil';

export const getHideAppPromoBannerUntilDate = () => {
  const hideAppPromoBannerUntilFromLocalStorage = localStorage.getItem(APP_PROMO_LOCAL_STORAGE_KEY);
  const hideAppPromoBannerUntil = hideAppPromoBannerUntilFromLocalStorage
    ? new Date(hideAppPromoBannerUntilFromLocalStorage)
    : null;

  return hideAppPromoBannerUntil;
};

export const setHideAppPromoBannerUntilDate = () => {
  const dateNow = new Date();
  dateNow.setMonth(dateNow.getMonth() + 1);
  localStorage.setItem(APP_PROMO_LOCAL_STORAGE_KEY, dateNow.toISOString());
};

interface IsAppPromoBannerVisibleParams extends UseMobileOs {
  data: StaticMobileAppsSmartAppBannerDto | undefined;
}

export const isAppPromoBannerVisible = ({ data, userOs }: IsAppPromoBannerVisibleParams) => {
  const hideAppPromoBannerUntil = getHideAppPromoBannerUntilDate();
  const dateNow = new Date();

  return Boolean(
    userOs &&
      (!hideAppPromoBannerUntil ||
        hideAppPromoBannerUntil.toString() === 'Invalid Date' ||
        hideAppPromoBannerUntil < dateNow) &&
      data?.appName &&
      data.bannerLink,
  );
};
